<template>
  <v-col :cols="cols">
    <v-card class="mx-1 mt-1 mb-1">
      <v-card-title class="pa-6 pb-3">
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <v-row no-gutters>
          <v-col cols="12" class="my-auto">
            <span
              class=""
              :style="{ 'font-size': text_font_size, 'font-weight': 'bold' }"
              >{{ title_number }}
            </span>
          </v-col>
          <v-col cols="12" class="my-auto">
            <span>
              {{ subTitle }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-switch
              class="ml-3"
              v-model="currentValue"
              inset
              @change="switchStateChange"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class YourComponentName extends Vue {
  @Prop({ type: String, required: true }) title_number!: string;
  @Prop({ type: String, required: false }) subTitle?: string;
  @Prop({ type: String, required: false, default: "4" }) cols!: string;
  @Prop({ type: String, required: true }) text_font_size!: string;
  @Prop({ type: String, required: true }) control!: string;
  @Prop({ type: String, required: false, default: null }) controlVariable?: string | null;
  @Prop({ type: Boolean, required: true }) value!: boolean;

  // Data property
  get currentValue(): boolean {
    return this.value;
  }

  set currentValue(newVal: boolean) {
    this.$emit('input', newVal); // standard v-model event
  }

  switchStateChange() {
    switch (this.control) {
      case "weather_adaptation":
        this.$emit("weatherAdaptationValChange", this.currentValue);
        break;
      case "heating_control":
        this.$emit("heatingControlValChange", this.currentValue);
        break;
      case "hot_water_control":
        this.$emit("hotWaterControlValChange", this.currentValue);
        break;
      case "lock_thermostat":
        this.$emit("lockThermostatValChange", this.currentValue);
        break;
      case "relay_control":
        this.$emit("relayStateChange", this.currentValue);
        break;
      case "db_en":
        this.$emit("deadbandEnable", this.currentValue);
        break;
      default:
        this.$emit("defaultAction", this.currentValue, this.controlVariable);
    }
  }
}
</script>


<style lang="scss">
@import "../../styles/app";

.dashboard-page {
  .page-title {
    padding-bottom: 20px;
    @include media-breakpoint-up(sm) {
      padding-bottom: 0;
    }
  }
  .apexcharts-legend-series {
    padding: 2px 5px 3px;
    display: flex;
    align-items: center;
    .apexcharts-legend-marker {
      margin-right: 8px;
    }
  }
  .main-chart-select {
    font-size: 1rem;
    margin-right: 10px;
    fieldset {
      border-width: 1px !important;
      border-color: $text-grey !important;
      color: $text-grey !important;
    }
    .v-select__selection {
      color: $text-color !important;
    }
  }
  .v-card {
    .v-card__text {
      .subtext {
        font-size: 1.142rem;
        font-weight: 400;
        color: $title-grey;
      }
      .subtext-index {
        font-size: 11px;
        color: $text-color;
        font-weight: 400;
      }
    }
  }
}

.v-menu__content {
  box-shadow: $card-shadow !important;
  .v-list-item__content .v-list-item__title {
    font-size: 1rem;
    font-weight: 400;
  }
}
.button-shadow {
  box-shadow: $button-shadow;
}
</style>
